import React from 'react';
import logoImg from '../../../../assets/lg.png';
import styles from './walletCardPreview.module.scss';

const fieldText = (v, fallback = '—') => {
    if (v === 0) return '0';
    return v || fallback;
};

export default function WalletCardPreview({
    bonusName = 'Бонусы',
    stripUrl,
    bgColor = '#edf3ed',
    textColor = '#000000',
    logo,
    balance,
    clientName,
    cashback,
    expire,
    tier,
    barcodeType = 'barcode',
    code,
}) {
    const balanceText = fieldText(balance, '0');

    return (
        <div className={styles.card} style={{ background: bgColor, color: textColor }}>
            <div className={styles.header}>
                <img className={styles.logo} src={logo || logoImg} alt="" />
                <span className={styles.brand} style={{ color: textColor }}>{bonusName}</span>
                <div className={styles.headerBalance}>
                    <span className={styles.label} style={{ color: textColor }}>Бонусов</span>
                    <span className={styles.headerValue} style={{ color: textColor }}>{balanceText}</span>
                </div>
            </div>

            <div
                className={styles.strip}
                style={stripUrl ? { backgroundImage: `url(${stripUrl})` } : { background: 'rgba(0,0,0,0.06)' }}
            >
                {!stripUrl && <span className={styles.stripEmpty} style={{ color: textColor }}>Картинка не загружена</span>}
            </div>

            <div className={styles.fields}>
                <div className={styles.field}>
                    <span className={styles.label} style={{ color: textColor }}>Клиент</span>
                    <span className={styles.value} style={{ color: textColor }}>{fieldText(clientName)}</span>
                </div>
                {tier && (
                    <div className={styles.fieldCenter}>
                        <span className={styles.label} style={{ color: textColor }}>Уровень</span>
                        <span className={styles.value} style={{ color: textColor }}>{tier}</span>
                    </div>
                )}
                <div className={styles.fieldRight}>
                    <span className={styles.label} style={{ color: textColor }}>Бонусы:</span>
                    <span className={styles.value} style={{ color: textColor }}>{cashback != null ? `${cashback}%` : '—'}</span>
                </div>
            </div>

            <div className={styles.fields}>
                <div className={styles.field}>
                    <span className={styles.label} style={{ color: textColor }}>Действует до</span>
                    <span className={styles.value} style={{ color: textColor }}>{fieldText(expire, 'Без срока')}</span>
                </div>
                <div className={styles.fieldRight}>
                    <span className={styles.label} style={{ color: textColor }}>Бонусный счёт</span>
                    <span className={styles.value} style={{ color: textColor }}>{balanceText}</span>
                </div>
            </div>

            <div className={styles.barcode}>
                <div className={barcodeType === 'qr' ? styles.qr : styles.bars} />
                <span className={styles.code}>{code || ''}</span>
            </div>
        </div>
    );
}
